import { nanoid } from "@reduxjs/toolkit";

const AmpleHireSelectTag = ({
  id,
  name,
  className = "",
  optionTagClassName,
  options,
  value,
  onChange,
  multiple,
  disabled,
  firstOptionDisabled,
  required,
  labelText,
  ...props
}) => {
  if (value === null) {
    value = multiple ? [] : "";
  }

  return (
    <select
      className={`ah-select ${className}`}
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      multiple={multiple}
      disabled={disabled}
      required={required}
      {...props}
    >
      <option value="" disabled>
        Select {labelText}
      </option>
      {options?.map(
        (curOption, index) =>
          curOption?.optionKey && (
            <option
              key={nanoid(5)}
              value={curOption?.optionValue}
              disabled={index === 0 && firstOptionDisabled}
            >
              {curOption.optionKey}
            </option>
          )
      )}
    </select>
  );
};

export default AmpleHireSelectTag;
